import axios from "axios";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ScrollContext } from "react-router-scroll-4";
import GraphQLClient from "graphql-js-client";
import { Header } from "./components/Header";
import {Helmet} from "react-helmet";
import typeBundle from "./types/types";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { fetchStore } from "./actions/merchstore";
import { Page404 } from "./components/Page404";
import { ProductPageLayout } from "@merchstores/frontend/layouts/ProductPageLayout";
import { CartPage } from "@merchstores/frontend/layouts/CartPage";
import { Footer } from "./components/Footer";
import { CollectionPageLayout } from "./layouts/CollectionPageLayout/component";
import { MerchStoreLogin } from "./components/MerchStoreLogin";
import { resolveMerchstoreSubdomain } from "./components/Merchstore";

require("dotenv").config();

const SHOPIFY_MERCH_SERVICES_STOREFRONT_URL = process.env.REACT_APP_SHOPIFY_MERCH_SERVICES_STOREFRONT_URL;
const SHOPIFY_MERCH_SERVICES_STOREFRONT_TOKEN = process.env.REACT_APP_SHOPIFY_MERCH_SERVICES_STOREFRONT_TOKEN;

export const storefrontClient = new GraphQLClient(typeBundle, {
  url: SHOPIFY_MERCH_SERVICES_STOREFRONT_URL,
  fetcherOptions: {
    headers: {
      "X-Shopify-Storefront-Access-Token": SHOPIFY_MERCH_SERVICES_STOREFRONT_TOKEN
    }
  }
});

export const App = () => {
  const dispatch = useDispatch()

  const merchstore = useSelector((state) => state.merchstore, shallowEqual);
  const user = useSelector((state) => state.user, shallowEqual);

  const [loginModalOpen, setLoginModalOpen] = useState(false)
  const [passwordRequired, setPasswordRequired] = useState(false)

  useEffect(() => {
    const storeSubdomain = resolveMerchstoreSubdomain();
    dispatch(fetchStore(storeSubdomain));
  }, []);

  useEffect(() => {
    if(merchstore) {
      // Check if there is a password
      axios.post("/.netlify/functions/checkMerchStorePassword", { subdomain: merchstore.subdomain })
      .then((res) => {
        if(res.data.passwordRequired) {              
          setPasswordRequired(true)
        }
      })
      .catch(err => {
        console.error('Failed getting MerchStore Password', err);
      })
    }
  }, [merchstore])

  useEffect(() => {
    if(passwordRequired) {
      let storeMatch = false;
      // Loop through the user's stores that they have access to and grant them access
      for(const userStore of user.storeCode) {
        if (userStore === merchstore.storeCode) {
          storeMatch = true
        }
      }
      if(!user.loggedIn || !storeMatch) {
        setLoginModalOpen(true)
      }
    }
}, [passwordRequired])

  const onCloseModal = () => {
    setLoginModalOpen(false)
    document.body.style.overflow = "scroll"
}

  if(loginModalOpen) {document.body.style.overflow = "hidden"}

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content=""
        />
        <title>Merchology MerchStore</title>
      </Helmet>
      {loginModalOpen && <MerchStoreLogin onCloseModal={onCloseModal} />}
      <BrowserRouter basename={"/"}>
          <Header />
          <ScrollContext>
            <Switch>
              <Route exact path={"/"} component={CollectionPageLayout} />
              <Route path={"/404"} component={Page404} />
              <Route exact path={"/cart"} component={CartPage} />
              <Route path={"/:productHandle"} component={ProductPageLayout} />
            </Switch>
          </ScrollContext>
      </BrowserRouter>
      <ToastContainer />
    <Footer />
    </>
  )
}
